import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { GlobalBackground } from "@/components/site/GlobalBackground";
import Home from "@/pages/Home";
import Vision from "@/pages/Vision";
import Registrations from "@/pages/Registrations";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import News from "@/pages/News";
import Careers from "@/pages/Careers";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import Team from "@/pages/Team";
import Events from "@/pages/Events";
import ContactPage from "@/pages/ContactPage";
import Services from "@/pages/Services";
import ProjectsPage from "@/pages/ProjectsPage";
import PortalAuth from "@/pages/portal/PortalAuth";
import FounderDashboard from "@/pages/portal/FounderDashboard";
import StartupWizard from "@/pages/portal/StartupWizard";
import StartupDetail from "@/pages/portal/StartupDetail";
import SpecialistDashboard from "@/pages/portal/SpecialistDashboard";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App min-h-screen text-slate-100">
      <GlobalBackground />
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/registrations" element={<Registrations />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/news" element={<News />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/team" element={<Team />} />
              <Route path="/events" element={<Events />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/portal" element={<PortalAuth />} />
              <Route path="/dashboard" element={<FounderDashboard />} />
              <Route path="/dashboard/new" element={<StartupWizard />} />
              <Route path="/dashboard/new/:id" element={<StartupWizard />} />
              <Route path="/dashboard/startup/:id" element={<StartupDetail />} />
              <Route path="/specialist" element={<SpecialistDashboard />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" richColors position="top-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
